import {
    SearchkitComponent,
    CheckboxFilterAccessor,
    renderComponent,
    CheckboxItemList,
    Panel,
} from 'searchkit'

export default class AlwaysDisplayedCheckboxFilter extends SearchkitComponent {
    static defaultProps = {
        listComponent: CheckboxItemList,
        containerComponent: Panel,
        collapsable: false,
        showCount: true,
    }

    constructor(props) {
        super(props)
        this.toggleFilter = this.toggleFilter.bind(this)
    }

    defineAccessor() {
        const { id, title, translations, label, filter } = this.props
        return new CheckboxFilterAccessor(id, {
            id,
            title,
            label,
            translations,
            filter,
        })
    }

    toggleFilter() {
        this.accessor.state = this.accessor.state.create(
            !this.accessor.state.getValue(),
        )
        this.searchkit.performSearch()
    }

    setFilters(keys) {
        this.accessor.state = this.accessor.state.setValue(keys.length > 0)
        this.searchkit.performSearch()
    }

    getSelectedItems() {
        if (this.accessor.state.getValue()) {
            return [this.props.label]
        }

        return []
    }

    render() {
        const {
            listComponent,
            containerComponent,
            showCount,
            title,
            id,
            label,
        } = this.props

        const disabled = false

        return renderComponent(
            containerComponent,
            {
                title,
                className: id ? `filter--${id}` : undefined,
                disabled,
            },
            renderComponent(listComponent, {
                items: [{ key: label, doc_count: this.accessor.getDocCount() }],
                selectedItems: this.getSelectedItems(),
                toggleItem: this.toggleFilter,
                setItems: this.setFilters.bind(this),
                showCount,
            }),
        )
    }
}
